module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-load-check"
    },
    on: {
      "click": _vm.showLoadCheckModal
    }
  }, [_c('p', {
    staticClass: "load-reference"
  }, [_vm._v("\n      " + _vm._s(_vm.decorated.reference_number) + "\n\n      "), _c('span', {
    staticClass: "load-status pull-right",
    class: _vm.decorated.weighbridge_status_class
  }, [_vm._v("\n        " + _vm._s(_vm.decorated.weighbridge_status_text) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Loading Date")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.loading_date) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Date")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.delivery_date) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Rego")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.registration) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', [_c('strong', [_vm._v("Configuration")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.configuration_description) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', {
    staticClass: "truncate"
  }, [_c('strong', [_vm._v("From")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.location_from.formatted_name) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-2"
  }, [_c('p', {
    staticClass: "truncate"
  }, [_c('strong', [_vm._v("To")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.decorated.location_to.formatted_name) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-dbe936c2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadCheckListItem.vue
// module id = 1082
// module chunks = 0